import { render, staticRenderFns } from "./confirmWindow.vue?vue&type=template&id=7aa12d3a&"
import script from "./confirmWindow.vue?vue&type=script&lang=js&"
export * from "./confirmWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports